import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { takeUntil } from 'rxjs/operators';

import { TranslationService, Unsubscribe } from '../../core';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.less'],
  host: {
    class: 'margin-center',
  },
})
export class AuthComponent extends Unsubscribe implements OnInit {
  constructor(
    private titleService: Title,
    private translationService: TranslationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.translationService
      .stream('PAGE.AUTH.LOGIN.TITLE')
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((translatedTitle: string) => {
        this.titleService.setTitle(`BrandVNO | ${translatedTitle}`);
      });
  }
}
